import { Component, OnInit, OnDestroy } from '@angular/core';
import { Injectable }      from '@angular/core';
import { Config } from "../../../environments/environment";
import * as Communication from '../../communication/index';
import {NotificationService} from "../common/NotificationService";
import { Router, ActivatedRoute,NavigationEnd, NavigationStart} from '@angular/router';
import {Location} from "@angular/common";
import {BehaviorSubject} from "rxjs";

import {Observable, EMPTY} from "rxjs";
import {tap} from "rxjs/operators";
import { Subscription } from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {formatDayMonthYear} from "../common/date-format";

import { BaseTokenRequestHandler } from "@openid/appauth/built/token_request_handler";
import { FetchRequestor } from "@openid/appauth/built/xhr";
import { AuthorizationServiceConfiguration } from "@openid/appauth/built/authorization_service_configuration";
import { TokenRequest } from "@openid/appauth/built/token_request";
import { RevokeTokenRequest } from "@openid/appauth/built/revoke_token_request";

@Injectable()
export class Authorization implements OnDestroy{

  public userProfile:any = null;
  public userAccount:any = null;
  private localLanguage:string;
  subscriptions:Subscription[] = [];

  private initializedSource:BehaviorSubject<boolean>;

  initialized$:Observable<boolean>;
  private tokenExpiry:number = undefined; //seconds

  tokenHandler:BaseTokenRequestHandler = null;
  configuration:any = null;

  constructor(protected usersApi:Communication.UsersService,
              private notificationService:NotificationService,
              private translate: TranslateService,
              private router: Router,
              private location: Location
  ){

    //language assigned before i18n
    this.localLanguage = JSON.parse(localStorage.getItem('account')).language;
    let namePlaceHolder = this.localLanguage == "tr" ? "isminiz" : "your name";
    let nameHint = "En az 7 karakter olmalı"; //this.localLanguage == "tr" ? "En az 7 karakter olmalı" : "Must be at least 7 characters";
    let contract = "<a href='https://imzayeri.com/kullanim-sartlari' target='_new'>Kullanım Şartlarını</a> kabul ediyorum."; //this.localLanguage == "tr" ? "<a href='/terms' target='_new'>Kullanım Şartlarını</a> kabul ediyorum." : "I agree the <a href='/terms' target='_new'>Terms of Service</a>.";

    // Set userProfile  and userAccount attributes of already saved profile
    this.userProfile = this.getProfile();
    this.userAccount = this.getAccount();

    this.initializedSource = new BehaviorSubject<boolean>(this.isInitializedAfterLogin());
    this.initialized$ = this.initializedSource.asObservable();
    let _self = this;

  }



  public parseHash() {

  }




  public onLoginSuccess(ownerObject:any, authResult:any) {
    // Fetch profile information
    ownerObject.lock.getProfile(authResult.accessToken, (error:any, profile:any) => {
      if (error) {
        // Handle error
        console.log(error);
        alert('Error: ' + error.error + '. Check the console for further details.');
        ownerObject.notificationService.displayError(error);
        return;
      }

      //check email verification
      if(profile.email_verified == false){
        let self = this;
        ownerObject.notificationService.showEmailNotVerifiedInfo(function(isConfirmed:boolean) {
          if(isConfirmed) {
            setTimeout(() => {
              self.logout();
              location.href="/";
            }, 0);

          }
        });
        ownerObject.lock.hide();
        return;
      }

      localStorage.setItem('access_token', authResult.idToken);
      localStorage.setItem('profile', JSON.stringify(profile));

      ownerObject.userProfile = profile;

      let language:any = ["https://imzayeri.com/language", "https://truepact.eu/language"];
      let userLanguage:any = this.localLanguage;

      if(ownerObject.userProfile.hasOwnProperty(language[0])) {
        language = ownerObject.userProfile[language[0]];
      } else if(ownerObject.userProfile.hasOwnProperty(language[1])) {
        language = ownerObject.userProfile[language[1]];
      }


      this.subscriptions.push(
        this.usersApi.usersGet(
          authResult.idToken
        ).subscribe(
          (response:any) => {
            console.log(response);
            let userMetadata = { language: response.language };
            ownerObject.updateProfile(userMetadata, false);
            console.log("Used language...: ", response.language);
          },
          (error)=>{
            console.log(error);
            let userMetadata = { language: userLanguage };
            ownerObject.updateProfile(userMetadata, false);
            console.log("Used language...: ", userLanguage);
          }
        )
      )

    });

  }


  public setUserAccount(subscription:Communication.Subscription, language:string){
    this.userAccount = this.getAccount() || {};
    this.userAccount.subscription = subscription;
    this.userAccount.language = language;

    localStorage.setItem('account',JSON.stringify(this.userAccount));

    console.log("userAccount : " + this.userAccount.subscription.plan.name + " " + this.userAccount.subscription.period + " " + this.userAccount.subscription.monthlySignedDocuments + " name: "+ this.userAccount.subscription.invoiceName);
  }


  /**
   * Re-reads the account from the server and caches the subscription it carries.
   * Returns the whole payload so a caller can also use the fields that are not cached —
   * deleteAccountAvailable and accountDeletion are computed live per call and must never be
   * read from the cache or re-derived.
   */
  public refreshAccount():Observable<Communication.UserInfo> {
    const token = this.getAccessToken();
    if (!token) { return EMPTY; }
    return this.usersApi.usersGet(token).pipe(
      tap((user:Communication.UserInfo) => {
        if (user && user.subscription) {
          this.setUserAccount(user.subscription, user.language ? user.language : (this.userAccount ? this.userAccount.language : undefined));
        }
      })
    );
  }

  public refreshSubscription(){
    this.subscriptions.push(
      this.refreshAccount().subscribe(
        () => {},
        (error) => { console.log(error); }
      )
    );
  }

  /**
   * A deactivated account can still read GET /users — every other authenticated endpoint refuses
   * it — so the sign-in would otherwise succeed and then fail on whatever the user clicked first.
   * Ends the session here instead, with a message that says why.
   *
   * Returns true when the account is deactivated and the caller should stop.
   */
  public rejectDeactivatedAccount(account:any):boolean {
    if (!account || !account.accountDeletion || !account.accountDeletion.deactivatedAt) {
      return false;
    }

    this.endDeactivatedSession(account.accountDeletion.deactivatedAt);
    return true;
  }

  /**
   * The same rejection arriving as a refusal rather than as a signed-in account.
   *
   * A deactivated sign-in is answered with 403 and code 309, carrying the deletion state in the
   * error body — so the branch above never runs, and without this the request would fall through
   * to a generic "invalid credentials" that tells the user nothing they can act on.
   *
   * Returns true when the caller should stop handling the error.
   */
  public rejectDeactivatedSignIn(error:any):boolean {
    const body = this.readErrorBody(error);
    if (!body || Number(body.code) !== 309) {
      return false;
    }

    this.endDeactivatedSession(body.accountDeletion ? body.accountDeletion.deactivatedAt : null);
    return true;
  }

  /**
   * Error bodies reach these callers in two shapes: HttpClient puts the parsed body on `error`,
   * while one older caller still reads `_body`, the string form from the HTTP client this
   * application used before. Reading only one of them would make the refusal invisible on whichever
   * path uses the other.
   */
  private readErrorBody(error:any):any {
    if (!error) { return null; }

    const candidates = [error.error, error._body];
    for (const candidate of candidates) {
      if (!candidate) { continue; }
      if (typeof candidate === 'object') { return candidate; }
      if (typeof candidate === 'string') {
        try { return JSON.parse(candidate); } catch { /* not this one */ }
      }
    }
    return null;
  }

  /** Says what happened and when, then ends the session. */
  private endDeactivatedSession(deactivatedAt:any) {
    this.notificationService.accountDeactivated(formatDayMonthYear(deactivatedAt));
    setTimeout(() => {
      // Clear the stored session here rather than leaving it to logout(). That removes the
      // credentials only after two round trips to the identity provider, and the navigation below
      // unloads the page long before they finish — so the session would outlive the rejection and
      // the next load would sign straight back in.
      this.clearStoredSession();
      location.href = "/";
    }, 3000);
  }

  /** Drops the stored session synchronously. */
  private clearStoredSession() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('account');
    localStorage.removeItem('access_token_ip');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token_ip_exp');
    this.userProfile = null;
    this.userAccount = null;
    this.tokenExpiry = undefined;
  }


  public isInitializedAfterLogin():boolean {
    if (
      this.authenticated() &&
      localStorage.getItem('access_token') != null &&
      localStorage.getItem('profile') != null &&
      localStorage.getItem('account') != null) {
      return true;
    }
    else {
      return false;
    }
  }



  public authenticated() : boolean{
    // Check if there's an unexpired JWT
    // It searches for an item in localStorage with key == 'id_token'
    if(this.tokenExpiry == undefined) {
      let token = localStorage.getItem("access_token");
      if (token != null) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        let jsonPayloadParsed = JSON.parse(jsonPayload);
        this.tokenExpiry = jsonPayloadParsed["exp"]*1000;
      }
    }
    return Date.now() < this.tokenExpiry;

  };

  public logout() {
    // To log out, we just need to remove
    // the user's profile and token

    const revokeTokenRequest = new RevokeTokenRequest({
      client_id: Config.WEB_CLIENT_ID,
      token: localStorage.getItem("refresh_token"),
      token_type_hint: "refresh_token"
    });

    this.tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
    AuthorizationServiceConfiguration.fetchFromIssuer("https://identity.ilerian.com", new FetchRequestor())
      .then((oResponse: any) => {
        this.configuration = oResponse;
        this.configuration.revocationEndpoint = "https://identity.ilerian.com/oxauth/restv1/revoke";
        console.log(oResponse)
        return this.tokenHandler.performRevokeTokenRequest(this.configuration,revokeTokenRequest);
      })
      .then((oResponse: any) => {
        console.log(oResponse)
        this.clearStoredSession();
        window.location.href = "https://identity.ilerian.com/oxauth/restv1/end_session?post_logout_redirect_uri="+Config.WEB_APP_URL;
      }).catch((oError: any) => {
        console.log(oError)
      });
  };

  public getAccessToken():string {
    return localStorage.getItem("access_token");
  }

  public getAccessTokenAuth0():string {
    return localStorage.getItem("access_token_auth0");
  }

  private getProfile():string {
    return JSON.parse(localStorage.getItem("profile"));
  }

  private getAccount():string {
    return JSON.parse(localStorage.getItem("account"));
  }


  public updateProfile(userMetadata:any, isUpdate:boolean) {

    if(localStorage.getItem("access_token_ip_exp") != null && Math.round(Date.now()/1000) - +localStorage.getItem('access_token_ip_exp') > 5){

      const tokenRequest = new TokenRequest({
        client_id: Config.WEB_CLIENT_ID,
        redirect_uri: Config.WEB_APP_URL + "/account",
        grant_type: "refresh_token",
        code: undefined,
        refresh_token: localStorage.getItem("refresh_token"),
        extras:undefined
      });

      this.tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
      AuthorizationServiceConfiguration.fetchFromIssuer("https://identity.ilerian.com", new FetchRequestor())
        .then((oResponse: any) => {
          this.configuration = oResponse;
          return this.tokenHandler.performTokenRequest(this.configuration, tokenRequest);
        })
        .then((oResponse) => {
          console.log(oResponse)
          this.subscriptions.push(
            this.usersApi.usersUpdatePut(
              this.getAccessToken(),
              JSON.stringify(userMetadata),
            ).subscribe(
              (profile:any) => {
                this.subscriptions.push(
                  this.usersApi.usersLoginGet(
                    this.getAccessToken(),
                    oResponse.accessToken
                  ).subscribe(
                    (loginResponse:any) => {

                      console.log(loginResponse);
                      let language = loginResponse.user.language;
                      let accountJson = loginResponse.user.subscription;
                      let account = {language:language,subscription:accountJson};
                      let profile = loginResponse.user;
                      profile.user_metadata = {
                        name:profile.name,
                        email:profile.email,
                        title:profile.title,
                        company:profile.company,
                        address:profile.address,
                        country:profile.country,
                        language:profile.language
                      }
                      localStorage.setItem('profile',JSON.stringify(profile));
                      localStorage.setItem('account',JSON.stringify(account));
                      localStorage.setItem('access_token',loginResponse.access_token);
                      localStorage.setItem('access_token_ip',oResponse.accessToken);
                      localStorage.setItem('refresh_token',oResponse.refreshToken);
                      localStorage.setItem('access_token_ip_exp',Math.round(((Date.now() / 1000) + 300)).toString());
                      this.translate.use(profile.language)
                      if (this.isInitializedAfterLogin()) {
                        if (this.rejectDeactivatedAccount(profile)) { return; }
                        this.initializedSource.next(true);
                        // location.href="/account";
                        if(profile.subscription.status == "SUSPENDED"){
                          this.notificationService.SuspendedSubscription();
                        }
                        location.reload();
                      } else {
                        console.log("Login failed. Redirecting login page again.");
                        setTimeout(() => {
                          this.logout();
                          location.href="/";
                        }, 300);
                      }
                    },
                    (error:any) => {
                      if (this.rejectDeactivatedSignIn(error)) { return; }

                      let json = JSON.parse(error._body);
                      if(json.code == 214){
                        console.log("Invalid Credentials")
                        this.notificationService.showInvalidCredentialsForLoginAlert();
                      } else if(json.code == 217){
                        console.log("Email Not Verified")
                        this.notificationService.showEmailNotVerifiedInfo(function() {
                          this.logout();
                        });
                      } else if(json.code == 203){
                        console.log("Server Error.")
                        this.notificationService.serverNotReachable();
                      } else {
                        console.log("Invalid Credentials")
                        this.notificationService.displayError(error);
                      }
                    }
                  )
                )
              },
              (error) => {
                console.log(error);
              }
            )
          )
        })
        .catch(oError => {
          console.log(oError)
        });

      return;
    }

    let userProfile:any = this.getProfile();
    if(userProfile.identity != null){

      this.subscriptions.push(
        this.usersApi.usersUpdatePut(
          this.getAccessToken(),
          JSON.stringify(userMetadata)
        ).subscribe(
          (profile:any) => {
            this.subscriptions.push(
              this.usersApi.usersLoginGet(
                this.getAccessToken(),
                localStorage.getItem("access_token_ip")
              ).subscribe(
                (response:any) => {
                  let language = response.user.language;
                  let accountJson = response.user.subscription;
                  let account = {language:language,subscription:accountJson};
                  let profile = response.user;
                  profile.user_metadata = {
                    name:profile.name,
                    email:profile.email,
                    title:profile.title,
                    company:profile.company,
                    address:profile.address,
                    country:profile.country,
                    language:profile.language
                  }
                  localStorage.setItem('profile',JSON.stringify(profile));
                  localStorage.setItem('account',JSON.stringify(account));
                  localStorage.setItem('access_token',response.access_token);
                  this.translate.use(profile.language)
                  if (this.isInitializedAfterLogin()) {
                    if (this.rejectDeactivatedAccount(profile)) { return; }
                    this.initializedSource.next(true);
                    if(profile.subscription.status == "SUSPENDED"){
                      this.notificationService.SuspendedSubscription();
                    }
                    location.reload();
                  } else {
                    console.log("Login failed. Redirecting login page again.");
                    setTimeout(() => {
                      this.logout();
                      location.href="/";
                    }, 300);
                  }

                },
                (error:any) => {
                  console.log(error);
                  if (this.rejectDeactivatedSignIn(error)) { return; }
                  this.notificationService.displayError(error)
                }
              )
            )
          },
          (error) => {
            console.log(error);
          }
        )
      )

    } else {

      let userUpdateRequest:any = {
        user_metadata: userMetadata
      };
      let name:any = ["https://imzayeri.com/name", "https://truepact.eu/name"];
      let nameBeforeUpdate:string = "";

      if(this.userProfile.hasOwnProperty(name[0])) {
        nameBeforeUpdate = this.userProfile[name[0]];
      } else if(this.userProfile.hasOwnProperty(name[1])) {
        nameBeforeUpdate = this.userProfile[name[1]];
      } else if(this.userProfile.hasOwnProperty("user_metadata") && this.userProfile.user_metadata.hasOwnProperty("name")) {
        nameBeforeUpdate = this.userProfile.user_metadata.name
      }

      //Update user at server
      this.subscriptions.push(this.usersApi.usersPut(
        JSON.stringify(userUpdateRequest),
        this.getAccessToken(),
      ).subscribe(
        (profile: any) => {
          //Update profile
          console.log("UserProfile Updated...");

          localStorage.setItem('profile', JSON.stringify(profile));
          this.userProfile = profile;

          //Update user at server
          this.subscriptions.push(this.usersApi.usersLoginPut(this.getAccessTokenAuth0(),this.getAccessToken(), this.userProfile.user_metadata.name, this.userProfile.user_metadata.language).subscribe(
            (usersResponse:Communication.UserInfo) => {
              console.log("UsersLogin OK...");
              this.translate.use(this.userProfile.user_metadata.language)
              if(isUpdate) {
                this.notificationService.accountInfoModified();
              }

              //if user language changes, change localLanguage and refresh page to load
              let localLanguage = this.userAccount.language;
              let userLanguage = this.userProfile.user_metadata.language;

              this.setUserAccount(usersResponse.subscription, usersResponse.language);

              if (this.isInitializedAfterLogin()) {
                if (this.rejectDeactivatedAccount(usersResponse)) { return; }
                this.initializedSource.next(true);

                if(usersResponse.subscription.status == "SUSPENDED"){
                  this.notificationService.SuspendedSubscription();
                }

              } else {

                console.log("Login failed. Redirecting login page again.");

                setTimeout(() => {
                  this.logout();
                  location.href="/";
                }, 300);
              }

              //refresh page if name and language changed.
              if (localLanguage != userLanguage || nameBeforeUpdate != usersResponse.name) {
                setTimeout(() => { window.location.reload(); }, 0);
              }

            }, //Bind to view
            err => {
              // Log errors if any
              console.log(err);
              this.notificationService.displayError(err);
            }
          ));


        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }
      ));

    }

  }

  public changePassword() {
    let profile:any = this.getProfile();

      this.subscriptions.push(
        this.usersApi.usersResetPasswordPost(
          this.userProfile.email
        ).subscribe(
          (response) => {
            this.notificationService.passwordChangeSent(this.userProfile.email);
          },
          (error) => {
            this.notificationService.displayError(error)
          }
        )
      )
  }

  /**
   *
   * Change Password
   * @param changePasswordRequest Change password inputs in json
   */
  /*
  public dbconnectionsChangePasswordPost (changePasswordRequest: any, extraHttpRequestParams?: any ) : Observable<string> {
    const path = this.authApi.basePath + 'dbconnections/change_password';

    let queryParameters = new URLSearchParams();
    let headerParams = this.authApi.defaultHeaders;

    for (var header in extraHttpRequestParams) {
      headerParams.append(header, extraHttpRequestParams[header]);
    }
    // verify required parameter 'changePasswordRequest' is not null or undefined
    if (changePasswordRequest === null || changePasswordRequest === undefined) {
      throw new Error('Required parameter changePasswordRequest was null or undefined when calling dbconnectionsChangePasswordPost.');
    }
    let requestOptions: RequestOptionsArgs = {
      method: 'POST',
      headers: headerParams,
      search: queryParameters
    };
    requestOptions.body = JSON.stringify(changePasswordRequest);

    return this.authApi.getHttp().request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.text();
        }
      });
  }
*/
  ngOnDestroy() {
    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
  }

}
